import React, { useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import divrse from "../assets/images/diverse.png";
import risk from "../assets/images/risk.png";
import middlewareConstants from "../../shared/middleware-constant";
import { middlewareService } from "../../shared/service";
import { setConsentApi } from "../services/waitlist-service";
import Diverse from "../assets/images/chart.png";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { utils } from "../../core/helpers/utils";
import { initBranch, trackEvent } from "../../core/helpers/branchio";

export default function ConsentPopup(props) {
  const [checked, setChecked] = React.useState(true);

  function modalHide() {
    props.toggle();
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("Bidd_Risk_Close");
    }
    initBranch().then(() => {
    trackEvent(`Bidd_Risk_Close`);
  }).catch(error => console.error('Error initializing Branch:', error))
  }

  const invest = () => {
    let headers = {
      "X-product": `orobonds:${props.product}`
    };
    let payload = {
      type: "obTransaction",
      consent: true,
    };
    setConsentApi(payload, headers)
      .then((result) => {
        const response = utils.parsePayload(result);
        if (response && response.successs) {
          props.toggle();
          props.goToPaymentOverview();
          {
            process.env.REACT_APP_RENDER_GA === "true" &&
            setAnalyticsEvent("Bidd_Risk_Invest");
          }
          initBranch().then(() => {
          trackEvent(`Bidd_Risk_Invest`);
        }).catch(error => console.error('Error initializing Branch:', error));
        }
      });
  };

  return (
    <Modal
      scrollable={true}
      isOpen={props.isOpen}
      className="consent-popup"
      size="lg"
      zIndex={9999}
      centered
    >
      <ModalHeader isOpen={props.isOpen} toggle={props.toggle}>
        <div className="consent-header d-flex align-items-center justify-content-between">
          <img src={process.env.REACT_APP_IMAGES_PATH + "biddeasy_white_logo.webp"} alt="logo"/>
          <p className="text-white mb-0">Please note</p>
        </div>
      </ModalHeader>
      <ModalBody>
        <Row className="consent-diverse">
          <p className="mt-2">
            Diversification is the key to having a successful investment
            portfolio.{" "}
          </p>
          <Col className="consent-para" lg={7}>
            <p>
              We can never predict the next pandemic, next geopolitical war,
              next natural disaster or next high inflation environment, but 
              we can definitely construct a portfolio that can lower the downside
              risk when such events occur. Alternate assets provide necessary diversification 
              to the overall portfolio giving better risk adjusted returns.

            </p>
          </Col>
          <Col className="consent-img" lg={5}>
            <img src={Diverse} alt="Diverse-img"/>
          </Col>
        </Row>
         <Row className="consent-credit">
          <p className="consent-liquidity">
            Risk and Returns of Alternate Assets compared to Other Asset Classes
          </p>
          <Col className="risk-para1" lg={12}>
            <img 
              src={process.env.REACT_APP_IMAGES_PATH + "altGraph.webp"} 
              alt="Graph-img"
            />
          </Col>
        </Row>
        <Row className="consent-credit">
          <p className="consent-liquidity">
            Different types of risk involved: Credit risk, Market Risk, Liquidity risk and 
             Fraud risk
          </p>
          <p>
            <span>Credit Risk:</span> Credit risk means the risk that an investor might 
            not be able to recover his / her invested principal amount because of an NBFC
            declaring bankruptcy. If the NBFC goes defaults, it will enter into bankruptcy 
            proceedings, which is a lengthy process. Therefore, credit risk increases as the
            tenure of the bond increases.<br />
            <br /><span> Liquidity Risk:</span> Consider the assets on the platform as illiquid 
            with a lock-in period till maturity. Most assets, while being listed on the stock 
            exchanges, may not have an active secondary market, making it challenging for the 
            investors to sell their holdings before maturity. We recommend you to invest an 
            amount which you are comfortable with and may not be required in the near term.  
            Returns in some products like MLDs are not fully realised till the maturity of 
            the product.
            <br/>
            The feature of ‘Anytime Liquidity’ on the platform provides liquidity to investors at a cost.
            <br />
            <br /><span>Fraud Risk:</span>Bonds and MLDs may be open to risk of sharing 
            incorrect/false information about the borrowers and collateral. We do a thorough 
            check before listing any opportunity for you but do not guarantee any returns/repayment 
            in case of fraud/default.
            <br />
            <br /><span>Other Risks:</span>In case of MLDs, Market Risk also needs to be considered. 
            It means that the returns of the MLD depends on the performance of the Underlying Market
            benchmark. Based on the volatility of the Underlying Market, returns of the MLD could also
            vary. However, the Principal will always be 100% protected. There can also be a risk of the returns of the Underlying Market going above the Cap (maximum returns) of the MLD.
          </p>
        </Row>
        <Row>
          <p className="text-small">
            Information contained herein is not intended to be a source of
            advice or credit analysis with respect to the material presented,
            and the information and/or documents contained in this website do
            not constitute investment advice.
          </p>
        </Row>
      </ModalBody>
      <ModalFooter className="justify-content-between">
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            defaultChecked={checked}
            onChange={() => setChecked(!checked)}
          />
          <p className="consent mb-0 ml-3">I understand</p>
        </div>
        <div className={props.isMobile ? "d-flex" : ""}>
          <Button onClick={modalHide} className="btn-close btn btn-light btn-lg ">
            Close
          </Button>
          <Button
            className={"btn-open btn btn-lg ml-2"}
            onClick={invest}
            disabled={!checked}
          >
            Invest
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
